// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".booking-sea-eq-data-grid .ag-header-cell-text {\n  color: #4283ff;\n  font-weight: bold;\n}\nbooking-sea-eq-data-grid-si .ag-header-cell-text {\n  font-weight: bold;\n}\nbooking-sea-eq-data-grid-si .data-red input.el-input__inner {\n  color: #FF0000;\n}\n", ""]);
// Exports
module.exports = exports;
